module.exports = __webpack_public_path__ + "img/xibao.e72cc04d.png";